<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container"><a id="page_i"></a>
<img alt="images" src="images/fm.jpg"/>
<p class="caption"><em class="italic">Moving up: A Matilda Scorpion flail tank moves on to its next task, 5 November 1942. (IWM)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_FM.vue?f75ba04e